// @ts-check

jQuery( '.burgerBun' ).on( 'click', function() {
  jQuery( '.burgerBun' ).toggleClass( "open" );
  jQuery( '.menu-mobile-menu-container' ).toggleClass( "open" );
} );

jQuery( '.menu-mobile-menu-container a' ).on( 'click', function() {
  jQuery( '.burgerBun' ).removeClass( "open" );
  jQuery( '.menu-mobile-menu-container' ).removeClass( "open" );
} );


const header = /** @type {HTMLElement}*/ ( document.getElementById( 'site-header' ) );
setHeaderScrollState();
window.addEventListener( 'scroll', setHeaderScrollState, { passive: true } );
window.addEventListener( 'resize', setHeaderScrollState, { passive: true } );

function setHeaderScrollState() {
  if ( window.scrollY > 5 ) {
    header.classList.add( 'scroll' );
  } else {
    header.classList.remove( 'scroll' );
  }
}

jQuery( '.nav-menu' ).on( 'click', function() {
  if ( window.innerWidth > 1200 ) {
    jQuery( '#sideMenu' ).animate( {
      width: '45%',
      padding: '120px',
    }, 300 );
  } else if ( window.innerWidth > 992 ) {
    jQuery( '#sideMenu' ).animate( {
      width: '45%',
      padding: '80px',
    }, 300 );
  } else {
    jQuery( '#sideMenu' ).animate( {
      width: '100%',
      maxWidth: '100%',
      padding: '50px',
    }, 300 );
  }
  // jQuery('#closeBanner').show();
  jQuery( '#sideMenu .side-menu-title' ).fadeIn( 600 );
  jQuery( '#sideMenu .side-menu-menu' ).fadeIn( 900 );
  jQuery( '#sideMenu #closeBanner' ).fadeIn( 2000 );
} );

jQuery( '#closeBanner' ).on( 'click', function() {
  jQuery( '#closeBanner' ).hide();

  jQuery( '#sideMenu .side-menu-title' ).fadeOut( 100 );
  jQuery( '#sideMenu .side-menu-menu' ).fadeOut( 100 );
  jQuery( '#sideMenu #closeBanner' ).fadeOut( 100 );

  jQuery( '#sideMenu' ).animate( {
    width: '0%',
    padding: '0',
  }, 500 );
} );